import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/CatalogPages/Handlers/LoadCatalogPageByPath";
import { getCatalogPageByPath } from "@store/Services/CategoryService";

replaceInChain(chain, RequestDataFromApi, async props => {
    props.apiResult = await getCatalogPageByPath(props.apiParameter);
});
